import { LocalStorageKeys } from "@vega-core/constants/cookies";
import { isFalsy } from "@vega-core/utils/isFalsy";

export const LocalStorageService = {
  getRefreshToken: (): string | null =>
    window.localStorage.getItem(LocalStorageKeys.RefreshToken),
  getOauthProvider: () => {
    const value = window.localStorage.getItem(LocalStorageKeys.OauthProvider);

    if (value === null) {
      return undefined;
    }

    return value as "COGNITO" | "OKTA";
  },

  getToken: (): string => {
    const currentStorage = window.localStorage.getItem(LocalStorageKeys.Token);

    return !isFalsy(currentStorage) ? currentStorage : "";
  },

  getTxId: (): string | null =>
    window.localStorage.getItem(LocalStorageKeys.TxId),

  getLpAuthLoginTaskCompleted: (): boolean =>
    window.localStorage.getItem(LocalStorageKeys.LpAuthLoginTaskCompleted) !==
    null,

  // Genuine "all login tasks done" signal, persisted by useTaskStateV2. Unlike
  // LpAuthLoginTaskCompleted (set as soon as the task list is fetched), this is
  // only true once the LP has actually completed every task.
  getLpTasksCompleted: (): boolean => {
    const raw = window.localStorage.getItem(LocalStorageKeys.TasksState);

    if (raw === null) {
      return false;
    }

    try {
      return Boolean((JSON.parse(raw) as { completed?: boolean }).completed);
    } catch {
      return false;
    }
  },

  removeAllTokens() {
    window.localStorage.removeItem(LocalStorageKeys.Token);
    window.localStorage.removeItem(LocalStorageKeys.RefreshToken);
    window.localStorage.removeItem(LocalStorageKeys.OauthProvider);
    window.localStorage.removeItem(LocalStorageKeys.TxId);
    window.localStorage.removeItem(LocalStorageKeys.LpAuthLoginTaskCompleted);
    window.localStorage.removeItem(LocalStorageKeys.TasksState);
  },

  removeTxId: () => {
    window.localStorage.removeItem(LocalStorageKeys.TxId);
  },

  setAppVersion: (appVersion: string) => {
    window.localStorage.setItem(LocalStorageKeys.AppVersion, appVersion);
  },

  setRefreshToken: (refreshToken: string) => {
    window.localStorage.setItem(LocalStorageKeys.RefreshToken, refreshToken);
  },
  setOauthProvider: (oauthProvider: "COGNITO" | "OKTA") => {
    window.localStorage.setItem(LocalStorageKeys.OauthProvider, oauthProvider);
  },
  setToken: (token: string) => {
    window.localStorage.setItem(LocalStorageKeys.Token, token);
  },
  setTxId: (txId: string) => {
    window.localStorage.setItem(LocalStorageKeys.TxId, txId);
  },
  setLpAuthLoginTaskCompleted: () => {
    window.localStorage.setItem(LocalStorageKeys.LpAuthLoginTaskCompleted, "1");
  },
  setUserId: (userId: string) => {
    window.localStorage.setItem(LocalStorageKeys.UserId, userId);
  },
};
